<template>
    <span>
        <div v-if="type === 'home'" class="d-flex justify-space-between mb-6 action-item">
            <div class="pr-6">
                <h3>Vous avez <strong>1 {{title}}</strong></h3>
                <p>Le locataire <span>xxx</span> {{textobject}} <span>{{object}}</span> pour le logement <span>adresse</span> à date du <span>12/06/2022</span></p>
            </div>
            <v-btn class="px-6 my-auto primary-button">{{textbutton}}</v-btn>
        </div>
        <div v-if="type === 'sponsoring'" class="d-flex justify-space-between mb-6 action-item">
            <div class="pr-6">
                <h3>Vous avez <strong>1 {{title}}</strong></h3>
                <p>Le locataire <span>xxx</span> {{textobject}} <span>{{object}}</span> pour le logement <span>adresse</span> à date du <span>12/06/2022</span></p>
            </div>
            <button-popup type="sponsoring" buttontext="Voir la candidature"></button-popup>
        </div>
    </span>
</template>

<style lang="scss">
    .action-item{
        padding: 1.5rem;
        border-radius: 10px;
        border-left: 10px solid $primary;
        box-shadow: 0px 4px 8px 0px rgba(79, 55, 84, 0.4);
        @include phone{
            flex-direction: column;
        }
        h3{
            color: $primary;
            font-weight: 400;
            text-transform: none;
            padding-bottom: 0.8rem;
        }
        p span{
            color: $primary;
        }
    }
</style>

<script>
    import buttonPopup from '@/components/ButtonPopup.vue'
    export default {
    name: 'RectangularBanner',
    components: { buttonPopup },
    props: ['type', 'title', 'textobject', 'object', 'textbutton'],
    data: () => ({})
    }
</script>